import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';

import { ExamCallsComponent } from './exam-calls.component';
import { AddEditExamCallComponent } from './components/add-edit-exam-call/add-edit-exam-call.component';
import { ExamCallService } from '../../../../services/exam-call/exam-call.service';
import { DownloadExamCallsComponent } from './components/download-exam-calls/download-exam-calls.component';
import { BulkEditExamBoardsComponent } from './components/bulk-edit-exam-boards/bulk-edit-exam-boards.component';
import { SchoolYearService } from '../../../../services/schoool-year/school-year.service';

const routes = [
    {
        path: 'pages/management/exam-calls',
        component: ExamCallsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_EXAM_CALLS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    },
    {
        path: 'pages/management/exam-calls/bulk-edit/:schoolYearId',
        component: BulkEditExamBoardsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_EXAM_CALLS_EDIT', // Reuse or create new permission
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        ExamCallsComponent,
        AddEditExamCallComponent,
        DownloadExamCallsComponent,
        BulkEditExamBoardsComponent,
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule
    ],
    exports: [
        ExamCallsComponent
    ],
    entryComponents: [
        AddEditExamCallComponent,
        DownloadExamCallsComponent,
    ],
    providers: [
        ExamCallService,
        SchoolYearService
    ]
})
export class ExamCallsModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/exam-calls/exam-calls.module.ts